import { useTranslation } from 'react-i18next';

import styles from './ContentEditor.module.scss';

export const Placeholder = () => {
  const { t } = useTranslation(['cms']);

  return <span className={styles.placeholder}>{t('cms:insert_your_text')}</span>;
};
